"use client"

import type { FeedbackMessage } from "@stockline/shared/types/core/feedback"
import { FEEDBACK_MESSAGE_TABLE } from "../../../lib/offline/resources/core/feedback-message/db"
import { useAISync } from "../../ai/providers/AISyncProvider"

/**
 * Sentinel id used when `feedbackId` is null. The Dexie reactive adapter
 * builds an index query against `feedbackId`; passing a value that no real
 * row can match keeps the query lookup-only (no full table scan) and yields
 * an empty array without short-circuiting the hook order.
 */
const NO_FEEDBACK_SENTINEL = "__no-feedback__"

export function useFeedbackMessages(
  feedbackId: string | null
): FeedbackMessage[] {
  const { reactive } = useAISync()
  const rows = reactive.useQuery<FeedbackMessage>(FEEDBACK_MESSAGE_TABLE, {
    feedbackId: feedbackId ?? NO_FEEDBACK_SENTINEL,
    orderBy: "createdAt",
  })
  return feedbackId ? rows : []
}
